
import { User } from '../../../domain/model/user';
import { Uuid } from '../../../domain/model/uuid/uuid.type';
import { BatchWeighingStoreCommand } from '../../../services/data-store/batch-weighing-store-command';
import { StoreAnimalWeighingSaveInfo } from './store-animal-weighing-save-info';

export class StoreBatchWeighingSaveInfo {
  constructor(
    readonly batchWeighingId: Uuid,
    readonly batchId: Uuid,
    readonly sectionId: Uuid,
    readonly animalWeighings: StoreAnimalWeighingSaveInfo[],
    readonly batchWeighingStoreCommand: BatchWeighingStoreCommand | undefined,
    readonly user: User
  ) { }

  hasBatchWeighingData(): boolean {
    return this.batchWeighingStoreCommand !== undefined;
  }
  hasAnimalWeighingData(): boolean {
    return this.animalWeighings.length > 0;
  }
}
export { BatchWeighingStoreCommand };

